export const DS_ACTION_BUTTONS_CLASSES = {
  Root: "ds-action-buttons",
  Group: "ds-action-buttons__group",
} as const;
